module.exports = __webpack_public_path__ + "img/aej1n-66wvl.004.153685c8.png";